import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import HpLazyImageWrapper from '../HpLazyImageWrapper/HpLazyImageWrapper';
import ResponsiveImage from '../ResponsiveImage';
import classnames from 'classnames';

import { HpRespTopHeroBannerImageItem_bannerItem as BannerItem } from './__generated__/HpRespTopHeroBannerImageItem_bannerItem.graphql';

import styles from './HpRespTopHeroBannerImageItem.scss';

type Props = {
    isVisible: boolean;
    handleClick: (item: BannerItem, index: number) => void;
    useLazyLoadImages?: boolean;
    index: number;
    bannerItem: BannerItem;
    itemId: string;
};

export const HpRespTopHeroImageBannerItemComponent: FC<Props> = ({
    isVisible,
    handleClick,
    bannerItem,
    useLazyLoadImages,
    index,
    itemId,
}) => {
    const {
        isFullBleedImage,
        cmsId,
        linkData,
        imageUrl,
        mobileImageUrl,
        cta,
        imageHeight,
        imageWidth,
        mobileImageHeight,
        mobileImageWidth,
        imageCopy,
    } = bannerItem;

    return (
        <>
            {imageCopy && (
                <span id={itemId} className={styles.imageCopy}>
                    {imageCopy}
                </span>
            )}
            {/* eslint-disable-next-line react/forbid-elements, jsx-a11y/anchor-has-content */}
            <a
                key={cmsId}
                aria-label={cta || undefined}
                aria-describedby={imageCopy ? itemId : undefined}
                href={linkData?.path || undefined}
                className={styles.bannerImgContainer}
                style={{ opacity: isVisible ? '1' : '0' }}
                onClick={() => handleClick(bannerItem, index)}
            >
                <HpLazyImageWrapper
                    useLazyLoad={useLazyLoadImages}
                    imageHeight={mobileImageHeight || imageHeight}
                    imageWidth={mobileImageWidth || imageWidth}
                >
                    <ResponsiveImage
                        // do not hide image if there is no copy bc automated a11y testing won't
                        // be able to detect this issue
                        ariaHidden={typeof imageCopy === 'string' && imageCopy !== ''}
                        className={classnames(styles.bannerImg, {
                            [styles.isFullBleed]: isFullBleedImage,
                        })}
                        src={imageUrl || mobileImageUrl || ''}
                    />
                </HpLazyImageWrapper>
            </a>
        </>
    );
};
export const HpRespTopHeroBannerImageItem = createFragmentContainer(
    HpRespTopHeroImageBannerItemComponent,
    {
        bannerItem: graphql`
            fragment HpRespTopHeroBannerImageItem_bannerItem on TopHeroBannerItem {
                cmsId
                imageCopy
                ... on TopHeroBannerItem @skip(if: $isMobile) {
                    imageUrl
                    imageHeight
                    imageWidth
                }
                ... on TopHeroBannerItem @include(if: $isMobile) {
                    mobileImageHeight
                    mobileImageWidth
                    mobileImageUrl
                }
                linkData {
                    path
                }
                cta
                isFullBleedImage
            }
        `,
    }
);
